import { render, staticRenderFns } from "./ClientAdmins.vue?vue&type=template&id=c5516ce0&scoped=true&"
import script from "./ClientAdmins.vue?vue&type=script&lang=js&"
export * from "./ClientAdmins.vue?vue&type=script&lang=js&"
import style0 from "./ClientAdmins.vue?vue&type=style&index=0&id=c5516ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5516ce0",
  null
  
)

export default component.exports